module.exports = __webpack_public_path__ + "static/media/128-raw-fit.5d5376bc.svg";